// frontend/src/samkalp-admin/panels/ContentStandardsPanel.js
import React from 'react';
import ContentStandardManager from '../../components/TenantAdmin/ContentStandardManager';

const ContentStandardsPanel = ({ slug }) => (
    <ContentStandardManager tenantSlug={slug} onStandardCreated={() => {}} />
);

export default ContentStandardsPanel;
